// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"dd2b7874","762":"34e916c1","768":"fddf750b","873":"b78a7572"}[chunkId] + ".chunk.js";
};